import { useMemo } from 'react';
import { useStore } from 'react-redux';
import { createInteractionEventHandlers } from 'store/personalisation/lib/createInteractionEventHandlers';

export function usePersonalisation() {
  const store = useStore();
  return useMemo(() => createInteractionEventHandlers(store), [store]);
}
